module.exports = __webpack_public_path__ + "media/images/flags/32/Cambodia-2e9dd969e8fecb44d793ce3dbc5456b9.png";